import "./Attributes.css";
import React, {memo, useCallback} from "react";
import {DataLoadingStatus} from "../../../Utils/enums";
import {
    createDivisionAttribute,
} from "../../../Utils/queries";
import {DivisionFull, DivisionAttribute} from "../../../Utils/response-types";
import AttributeRow from "./AttributeRow";

const AttributesNav = ({selectedDivision, setDivisions, status, setStatus}: {selectedDivision: DivisionFull, status: DataLoadingStatus, setStatus: React.Dispatch<React.SetStateAction<DataLoadingStatus>>, setDivisions: React.Dispatch<React.SetStateAction<DivisionFull[]>>}) => {
    const updateDivisionAttributes = useCallback((div_id: number, new_attributes: DivisionAttribute[]) => {
        setDivisions((prev) =>
          prev.map((div) =>
            div.division_id === div_id
              ? { ...div, attributes: new_attributes }
              : div
          )
        );
    }, [setDivisions]);

    const handleAddAttribute = () => {
        const new_att_name = prompt("Enter the attribute name:");
        if (new_att_name !== null && new_att_name.length > 0) {
            setStatus(DataLoadingStatus.Loading);
            const div_id = selectedDivision.division_id;
            const old_atts_list = selectedDivision.attributes;
            updateDivisionAttributes(div_id, [...old_atts_list, {division_att_id: -1, division_id: div_id, attribute_name: new_att_name}]);
            createDivisionAttribute(selectedDivision.division_id, new_att_name).then(resp => {
                if (resp.errorCode !== undefined || !resp.success) {
                    alert(resp.message || `Error: ${resp.errorCode}`);
                    setStatus(DataLoadingStatus.Loaded);
                    updateDivisionAttributes(div_id, old_atts_list);
                } else {
                    alert("Attribute added successfully!");
                    setStatus(DataLoadingStatus.NotLoaded);
                }
            });
        } else {
            alert("Cannot create the attribute without name!");
        }
    }

    return (
        <nav className="attributes-nav">
            <h2 className="attributes-heading">Attributes:</h2>
            {(status !== DataLoadingStatus.Loaded || !(selectedDivision)?.attributes.length) &&
                <p id="a-status">{
                    status === DataLoadingStatus.Loading ? "Fetching..." :
                        status === DataLoadingStatus.Error ? "Error loading division data" :
                            !(selectedDivision)?.attributes.length ? "Nothing here..." : ""
                }</p>
            }
            <div id="attributes-container">{
                (selectedDivision)?.attributes.map((att, idx, self) => <AttributeRow
                    key={att.division_att_id} row={att} att_list={self}
                    setDivisionAttributes={updateDivisionAttributes} setStatus={setStatus}/>)
            }</div>
            <button className="add-att-btn"
                    disabled={status === DataLoadingStatus.Loading}
                    onClick={handleAddAttribute}>Add New
            </button>
        </nav>
    );
};


export default memo(AttributesNav);